<template>
  <div>
    <div v-show="isVisible" class="dropdown-overlay" v-on:click="$emit('toggle-dropdown')"></div>

    <transition name="dropdown-entrance">
      <div v-show="isVisible" class="dropdown-menu tc" :class="{ 'is-active': isVisible }">
        <p>
          Press
          <strong>H</strong> to load this menu from anywhere
        </p>

        <section class="action-group action-group--row">
          <div class="action-group__item">
            <a class="action-group__action action-group__chunky" href="/">
              <icon-base width="30" height="30" iconColor="rgba(255,255,255,1)" icon-name="imbox">
                <icon-imbox />
              </icon-base>Imbox
            </a>
          </div>
          <div class="action-group__item">
            <a class="action-group__action action-group__chunky" href="/resume">
              <icon-base width="30" height="30" iconColor="rgba(255,255,255,1)" icon-name="feed">
                <icon-feed />
              </icon-base>Resume
            </a>
          </div>
          <div class="action-group__item">
            <a class="action-group__action action-group__chunky" href="/files">
              <icon-base width="30" height="30" iconColor="rgba(255,255,255,1)" icon-name="files">
                <icon-files />
              </icon-base>All Files
            </a>
          </div>
        </section>

        <section class="action-group">
          <h5 class="action-group__title">Other stuff</h5>

          <div class="action-group__item">
            <a class="action-group__action--contacts action-group__action" href="/contact">
              <icon-base width="20" height="20" iconColor="rgba(255,255,255,1)" icon-name="contact">
                <icon-contact />
              </icon-base>Contact Nicola
            </a>
          </div>
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "DropdownMenu",
  props: ["isVisible"]
};
</script>

